import { render, staticRenderFns } from "./InDevelopment.vue?vue&type=template&id=58487fa1&scoped=true"
import script from "./InDevelopment.vue?vue&type=script&lang=js"
export * from "./InDevelopment.vue?vue&type=script&lang=js"
import style0 from "./InDevelopment.vue?vue&type=style&index=0&id=58487fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58487fa1",
  null
  
)

export default component.exports